export default { sha: '45d18d027bb1de3604fba509ed66a07e185fb1eb', buildNumber: 'undefined' }
